import React, {useState, useEffect} from 'react';
import Autosuggest from 'react-autosuggest';
import cx from 'classnames';
import {alertByError} from 'utils/alerts';
import {getPublicAccountOccupations} from 'api/common';
import {defaultTheme} from 'react-autosuggest/dist/theme';
import LocalStorage from 'utils/localStorage';
import {isEmpty} from 'lodash';
import {REGEXP_FEEDBACK} from 'configs';
import escapeStringRegexp from 'escape-string-regexp';

import {FormFeedback, Input} from 'reactstrap';

InputSuggestionOccupations.defaultProps = {
  onSuggestionSelected: () => {},
};

function InputSuggestionOccupations(props) {
  const {
    defaultValue,
    name,
    placeholder,
    required,
    onGetValue,
    disabled,
    ...rest
  } = props;
  const storedData = LocalStorage.occupations;

  const [value, setValue] = useState(defaultValue || '');
  const [initialSuggestion, setInitialSuggestion] = useState(storedData);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (isEmpty(storedData)) {
      load();
    }
  }, []);

  const load = async () => {
    try {
      const {data} = await getPublicAccountOccupations();

      LocalStorage.occupations = data;
      setInitialSuggestion(data);
    } catch (e) {
      await alertByError(e);
    }
  };

  const getSuggestion = async (value) => {
    const regex = new RegExp(`\\b${escapeStringRegexp(value)}\\b`, 'i');

    setSuggestions(
      initialSuggestion.filter((suggestion) => {
        return suggestion.match(regex);
      })
    );
  };

  const onSuggestionsClearRequested = () => setSuggestions([]);
  const onSuggestionsFetchRequested = (option) => getSuggestion(option.value);
  const renderSuggestion = (suggestion) => suggestion;

  const getSuggestionValue = (suggestion) => suggestion;
  const onInputChange = (e, {newValue}) => {
    setValue(newValue || '');
    if (onGetValue) onGetValue(newValue || '');
  };
  const onSuggestionSelected = (e, value) => {
    return props.onSuggestionSelected(value.suggestion);
  };

  const inputProps = {
    name: name,
    value: value,
    required: required,
    onChange: onInputChange,
    placeholder: placeholder,
    className: cx('form-control', {
      'form-control-sm': props.size === 'sm',
      'form-control-lg': props.size === 'lg',

      [props.className]: !!props.className,
    }),
    autoFocus: props.autoFocus,
    maxLength: '200',
    disabled,
  };

  function renderInputComponent(inputProps) {
    return (
      <div>
        <Input {...inputProps} />
        {required && <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>}
      </div>
    );
  }

  const containerProps = {
    className: cx({
      'react-suggest--valid': required ? !!value : true,
      'react-suggest--invalid': required ? !value : false,
    }),
  };

  return (
    <Autosuggest
      theme={{
        ...defaultTheme,
        inputFocused: {
          boxShadow: '0 0 10px rgba(51,0,114,.1)',
        },
        inputOpen: {
          outline: 'none',
          boxShadow: '0 0 10px rgba(51,0,114,.1)',
        },
      }}
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      focusInputOnSuggestionClick={false}
      highlightFirstSuggestion={false}
      containerProps={containerProps}
      inputProps={inputProps}
      renderInputComponent={renderInputComponent}
      onSuggestionSelected={onSuggestionSelected}
      {...rest}
    />
  );
}

export default InputSuggestionOccupations;
